<template>
  <div class="vipProductList-box">
    <div class="previewsbox flex just-center" v-if="filterTableList && filterTableList.length > 0">
      <ul class="flex ">
        <li v-for="(item,index) in filterTableList" :key="index" class="pitem">
          <div class="flex just-center  align-item-center">
            <img-load
                height="30px"
                v-if="showImgLoad && item.img"
                :src="imgUrl + '/' + item.img"
            ></img-load>
            <div class="ml-10">
              <div class="fz12">{{item.name}}</div>
              <div class="fz11">{{item.desc}}</div>
              <div class="fz10">花费{{item.price}}积分</div>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <!--操作栏-->
    <div class="action-bar">
      <el-button
        type="primary"
        size="small"
        @click="handleOpenEdit('add', tableData)"
        class="add-input"
        >+新增</el-button
      >
      <el-button
          type="primary"
          size="small"
          @click="handleQuery()"
          class="add-input"
      >刷新</el-button
      >
    </div>
    <!--数据表格-->
    <el-table
      :data="tableData"
      border
      size="small"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column  label="序列" align="center" width="60">
        <template slot-scope="scope">
          {{scope.$index+1}}
        </template>
      </el-table-column>
      <el-table-column label="类型" align="center"   width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.type=='VIP'">兑换会员</span>
          <span v-if="scope.row.type=='FREE'">兑换观影券</span>
          <span v-if="scope.row.type=='GIFT'">神秘礼物</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="名称" align="center" width="100"></el-table-column>
      <el-table-column label="封面图" align="center" width="80">
        <template slot-scope="scope">
          <img-load
              width="40px"
              v-if="showImgLoad && scope.row.img"
              :src="imgUrl + '/' + scope.row.img"
          ></img-load>
          <span v-else>暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="描述" align="center" width="180"></el-table-column>
      <el-table-column prop="price" label="所需积分" align="center"   width="100">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.price" class="center-input" @blur="handlerField('price',scope.$index,true)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="vipDays" label="VIP天数" align="center"   width="100">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.vipDays" class="center-input"  @blur="handlerField('vipDays',scope.$index,true)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="vipDays" label="观影券面值/张" align="center"   width="200">
        <template slot-scope="scope">
          <div class="flex align-item-center">
            <el-input v-model.number="scope.row.qnum" class="center-input ml-5"  @blur="handlerField('qnum',scope.$index,true)"></el-input>
            <span class="ml-3 mr-2">张</span>
            <el-input v-model.number="scope.row.qprice" class="center-input"  @blur="handlerField('qprice',scope.$index,true)"></el-input>
            <span class="ml-3 mr-2">元</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="发布状态" align="center"  width="150">
        <template slot-scope="scope">
          <el-switch
              v-model.number="scope.row.status"
              active-color="#13ce66"
              class="fz12"
              inactive-color="#909399"
              :active-value="1"
              :inactive-value="0"
              active-text="开启"
              @change="handlerField('status',scope.$index,true)"
              inactive-text="关闭">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="sorted" label="排序" align="center"  width="80">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.sorted" class="center-input" @blur="handlerField('sorted',scope.$index,true)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" width="150">
        <template slot-scope="scope">
          <span>{{scope.row.updatedAt | changeDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" min-width="180">
        <template slot-scope="scope">
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="handleOpenEdit('edit', scope.row)"
          ></el-button>
          <el-button
              type="info"
              size="mini"
              title="快速复制"
              icon="el-icon-document-copy"
              @click="handlerCopy( scope.row.id)"
          ></el-button>
          <el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="handleRemove(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <addedit
      ref="positionAction"
      @callback="handlerList"
    ></addedit>
  </div>
</template>
<script>
import API from "@/api/checkPrize";
import addedit from "./components/addedit";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      showImgLoad: false,
      tableData: [],
      // 列表请求参数
      params: {
        status: -1,
      },
    };
  },
  components: {
    addedit,
  },
  created() {
    this.handlerListMain(this.params);
  },
  computed:{
    filterTableList(){
      return this.tableData.filter(c=>c.status == 1).sort((a,b)=>a.sorted - b.sorted)
    }
  },
  methods: {
    // 请求商品列表
    handlerListMain() {
      this.loading = true;
      API.list(this.params)
        .then((res) => {
          this.showImgLoad = true;
          if (res.code === 200 && res.data.length > 0) {
            this.tableData = res.data;
          }
          this.loading = false;
        })
        .catch(() => {
          this.showImgLoad = false;
          this.loading = false;
        });
    },

    handleQuery(){
      this.handlerListMain()
    },

    // 监听编辑、或者添加成功过后重新拉去数据
    handlerList() {
      this.handlerListMain();
    },

    // 快速修改值
    handlerField(field,index,flag) {
      var id = this.tableData[index].id
      var value = this.tableData[index][field]
      if(flag)value = parseInt(value)
      API.field({id:id,field:field,value:value}).then(res=>{
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("复制失败！");
        }
      })
    },

    // 快速复制
    handlerCopy(id) {
      API.copy({id:id}).then(res=>{
        if (res.code === 200) {
          this.$message({
            message: "复制成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("复制失败！");
        }
      })
    },
    // 删除管理员
    handleRemove(row) {
      this.$confirm("您确定要删除当前项吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.remove({ id: row.id }).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.handlerListMain();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    handleOpenEdit(type, data) {
      if(type == 'add')data.sorted = this.tableData.length + 1
      this.$refs.positionAction.open(type, data);
    },
  },
};
</script>

<style scoped lang="scss">
.vipProductList-box {
  display: flex;
  height: 100%;
  flex-direction: column;
}
.previewsbox{
  background:#eee;
  padding:20px 10px;
  border-radius: 4px;
  margin: 5px 0;
  min-height: 100px;
  .pitem{
    margin: 0 10px;
    font-size:11px;
    padding:10px;
    background-color: #ffab00;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    font-weight: 1000;
    &:hover{
      color:#fff;
    }
  }
}
</style>
